<template>
    <div class="modal-container">
        <div class="modal-form-container">
            <div class="title-box">
                <h2 v-if="reprint">{{ getString('reimpressao_TEF') }}</h2>
                <h2 v-else>{{ getString('cancelamento_TEF') }}</h2>
            </div>
        </div>
        <template v-if="funcoesAdministrativasOptions.length === 0">
            <div class="form">
                <div class="config-item distance-bottom">
                    <div class="label-container">
                        <label for="nsu" v-text="getString('NSU')"></label>
                    </div>
                    <input type="text" id="nsu" v-model="rawNsu" @focus="show" data-layout="numeric" autocomplete="off"
                        @input="sanitizeNsu">
                </div>

                <div class="config-item distance-bottom">
                    <div class="label-container">
                        <label for="nfceCode" v-text="getString('nota_fiscal')"></label>
                    </div>
                    <input type="text" id="nfceCode" v-model="rawNfceCode" @focus="show" data-layout="numeric"
                        autocomplete="off" @input="sanitizeNfceCode">
                </div>

                <div class="config-item distance-bottom">
                    <div class="label-container">
                        <label for="date" v-text="getString('data')"></label>
                    </div>
                    <input type="text" id="date" v-model="rawDate" v-mask="'##/##/####'" @focus="show"
                        data-layout="numeric" placeholder="DD/MM/AAAA" autocomplete="off" @input="sanitizeDate">
                </div>

                <div class="config-item distance-bottom">
                    <div class="label-container">
                        <label for="value" v-text="getString('valor')"></label>
                    </div>
                    <input type="text" id="value" v-model="rawValue" @focus="show" :layout="layout" autocomplete="off"
                        @input="sanitizeValue">
                </div>

                <div class="sale-type-radios">
                    <div v-for="(saleType, key) in saleTypes" :key="key" class="option">
                        <div class="container-input">
                            <input class="styled-input" :id="'canceltef' + key" @focus="hide" type="checkbox"
                                :value="saleType" v-model="selectedSaleType" @change="saleTypeChange(saleType, $event)">
                            <label class="checkmark radio" :for="'canceltef' + key"></label>
                        </div>
                        <label :for="'canceltef' + key">
                            <span v-text="saleType.name"></span>
                        </label>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="main-area">
                <div class="funcoes-administrativas-options" v-if="funcoesAdministrativasOptions.length > 0">
                    <span class="option" v-for="(option) in funcoesAdministrativasOptions" :key="option"
                        @click="setFuncoesAdministrativasSelected(option)">{{ option }}</span>
                </div>
                <div class="funcoes-administrativas-options" v-else-if="tefMessage">
                    <div class="message-box">
                        <span class="message">{{ tefMessage }}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="main-area funcoes-administrativas-message-box" v-if="tefMessage">
            <div class="funcoes-administrativas-options">
                <div class="message-box">
                    <span class="message">{{ tefMessage }}</span>
                </div>
            </div>
        </div>
        <div class="prod-item-footer">
            <DefaultButton :text="getString('voltar')" outlined="true" @defaultBtnClick="modalCancel()"></DefaultButton>
            <DefaultButton
                :text="btnParams.text"
                :disabled="btnParams.disabled"
                @defaultBtnClick="modalConfirm()"></DefaultButton>
        </div>

        <div class="overlay" v-if="chooseWallet"></div>
        <div class="wallet-modal" v-if="chooseWallet">
            <div class="title-box">
                <h2 v-text="walletTitle"></h2>
            </div>
            <div class="main-area">
                <DefaultButton v-for="(wallet, key) in walletOptions" :key="key" class="wallet-button"
                    :text="wallet.name" :disabled="disabledWalletButtons" @defaultBtnClick="walletSelect(wallet)">
                </DefaultButton>
            </div>
        </div>
        <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :data-layout="layout"
            :cancel="hide" :accept="accept" :input="input" :next="next" />
    </div>
</template>

<script>
import Vue from 'vue'
import Util from '@/assets/libs/util'
import eventModule from '@/assets/libs/eventModule'
import DefaultButton from '@/components/DefaultButton'
import PaymentController from '@/assets/controllers/PaymentController'
import VueTouchKeyboard from 'vue-touch-keyboard'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import LocaleController from '@/assets/controllers/LocaleController'
import waitForDOMUpdate from '@/assets/libs/waitForDOMUpdate'

Vue.use(VueTouchKeyboard)
Vue.use(style)

export default {
    name: 'CancelTefModal',
    components: {
        DefaultButton,
        'vue-touch-keyboard': VueTouchKeyboard.component
    },
    data () {
        return {
            visible: false,
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            layout: keyboardLayout.EXTENDED_NUMERIC,
            input: null,
            rawNsu: null,
            rawDate: null,
            rawValue: null,
            rawNfceCode: null,
            nsu: null,
            date: null,
            value: null,
            nfceCode: null,
            controlsEnabled: true,
            selectedSaleType: [],
            chooseWallet: false,
            disabledWalletButtons: false,
            walletTitle: '',
            walletOptions: [],
            reprint: false,
            funcoesAdministrativasOptions: [],
            tefMessage: '',
            btnParams: {
                text: '',
                disabled: false
            }
        }
    },
    created () {
        this.saleTypes = [
            {
                name: this.getString('debito'),
                code: '1'
            },
            {
                name: this.getString('credito'),
                code: '2'
            },
            {
                name: this.getString('pix_carteira_digital'),
                code: '10'
            }
        ]

        eventModule.$on('showCancelWalletOptions', this.showCancelWalletOptions)
        eventModule.$on('titleReceived', this.titleReceived)
        eventModule.$on('optionsReceived', this.optionsReceived)
        eventModule.$on('setTefMessage', this.setTefMessageCancelTef)
        eventModule.$on('showFuncoesAdministrativasOptions', this.showFuncoesAdministrativasOptions)
        let params = this.cancelData || this.reprintData
        if (params) {
            this.rawNsu = params.nsu
            this.rawNfceCode = params.nfceCode
            this.rawDate = params.saleDate
            if (params.saleValue != null) {
                this.rawValue = params.saleValue.toString()
            }

            if (params.saleType === '1') {
                this.selectedSaleType.push(this.saleTypes[1])
            }
            if (params.saleType === '2') {
                this.selectedSaleType.push(this.saleTypes[0])
            }
            if (params.saleType === 'H') {
                this.selectedSaleType.push(this.saleTypes[2])
            }
            this.reprint = !!this.reprintData && !!this.reprintData.nsu
            this.btnParams.text = this.reprint ? this.getString('reimprimir_TEF') : this.getString('cancelar_TEF')
            this.$emit('enableOverlayClick')
        }
    },
    beforeDestroy () {
        eventModule.$off('showCancelWalletOptions', this.showCancelWalletOptions)
        eventModule.$off('titleReceived', this.titleReceived)
        eventModule.$off('optionsReceived', this.optionsReceived)
        eventModule.$off('setTefMessage', this.setTefMessageCancelTef)
        eventModule.$off('showFuncoesAdministrativasOptions', this.showFuncoesAdministrativasOptions)
        this.reprint = false
    },
    props: ['cancelData', 'reprintData'],
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        sanitizeNsu: function () {
            this.rawNsu = this.rawNsu.replace(/[^0-9]+/g, '')
        },
        sanitizeNfceCode: function () {
            this.rawNfceCode = this.rawNfceCode.replace(/[^0-9]+/g, '')
        },
        sanitizeDate: function () {
            this.rawDate = this.rawDate.replace(/[^0-9/]+/g, '')
        },
        sanitizeValue: function () {
            this.rawValue = this.rawValue.replace(/[^0-9,.]+/g, '')
        },
        showCancelWalletOptions: function () {
            if (!this.chooseWallet) this.chooseWallet = true
        },
        titleReceived: function (eventData) {
            this.walletTitle = eventData.title
        },
        optionsReceived: function (eventData) {
            let options = eventData.options.split(';')
            let lastElementIsEmpty = options[options.length - 1] === ''
            if (lastElementIsEmpty) options.pop()

            options.forEach((option, idx, array) => {
                let currentOption = {
                    name: '',
                    code: ''
                }
                let index = option.indexOf(':')
                currentOption.name = option.slice(index + 1)
                currentOption.code = option.slice(0, index)
                array[idx] = currentOption
            })

            options = Util.removePixSaquePixTroco(options)

            this.walletOptions = options
        },
        walletSelect: function (wallet) {
            if (!this.disabledWalletButtons) {
                PaymentController.setDigitalWallet(wallet.code)
                this.disabledWalletButtons = true
            }
        },
        modalCancel: function () {
            PaymentController.cancelPayment()
            if (this.controlsEnabled) {
                this.$emit('closeModal')
            }
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        next: function () {
            let inputs = document.querySelectorAll('input')
            let found = false;
            [].forEach.call(inputs, (item, i) => {
                if (!found && item === this.input && i < inputs.length - 1) {
                    found = true
                    this.$nextTick(() => {
                        inputs[i + 1].focus()
                    })
                }
            })
            if (!found) {
                this.input.blur()
                this.hide()
            }
        },
        modalConfirm: async function () {
            if (this.controlsEnabled) {
                this.btnParams.text = this.getString('aguarde')
                this.btnParams.disabled = true
                await waitForDOMUpdate.waitForDOMUpdate()
                this.controlsEnabled = false
                let result = this.validateInputs()
                if (result.isValid) {
                    this.$emit('disableOverlayClick')
                    let resultTef = null
                    if (this.reprint) {
                        resultTef = await PaymentController.reprintTef(this.nsu, this.date, this.value, this.selectedSaleType[0].code, this.nfceCode)
                        if (resultTef && resultTef.error) {
                            Util.showInfoModal(resultTef.errorType)
                        }
                    } else {
                        if (Util.isTransire()) {
                            await PaymentController.cancelTransactionTransire(this.nsu, '', this.nfceCode, null)
                        } else {
                            resultTef = await PaymentController.cancelTef(this.nsu, this.date, this.value, this.selectedSaleType[0].code, this.nfceCode)
                        }
                        if (resultTef && resultTef.error) {
                            Util.showInfoModal(resultTef.errorType)
                        }
                    }
                    PaymentController.clearDigitalWallet()
                    this.controlsEnabled = true
                    this.$emit('enableOverlayClick')
                    this.$emit('closeModal')
                } else {
                    Util.showInfoModal(result.message)
                }
                this.controlsEnabled = true
            }
            this.btnParams.text = this.reprint ? this.getString('reimprimir_TEF') : this.getString('cancelar_TEF')
            this.btnParams.disabled = false
            eventModule.$emit('refreshCoupons')
        },
        validateInputs: function () {
            let result = {
                isValid: true,
                message: ''
            }

            if (this.rawNsu == null || this.rawNfceCode == null || this.rawDate == null || (this.rawValue == null || this.rawValue === '')) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            this.nsu = this.rawNsu.replace('.', '').replace(',', '')
            this.nfceCode = this.rawNfceCode.replace('.', '').replace(',', '')
            this.date = this.rawDate.replace(/\D+/g, '').trim()
            this.rawValue = this.rawValue.replace(',', '.')
            this.value = parseFloat(this.rawValue).toFixed(2)
            this.value = this.value.replace('.', ',')

            let nsuIsEmpty = this.nsu.length === 0
            let nfceCodeIsEmpty = this.nfceCode.length === 0
            let dateIsEmpty = this.date.length === 0
            let valueIsEmpty = this.value.length === 0

            if (nsuIsEmpty || dateIsEmpty || valueIsEmpty || nfceCodeIsEmpty) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            if (this.date.length < 8) {
                result.isValid = false
                result.message = this.getString('data_informada_formato')
                return result
            }

            let typedValue = this.rawValue.replace('.', ',')
            let parts = typedValue.split(',')
            let decimalPart = parts[1]
            if (decimalPart && decimalPart.length > 2) {
                result.isValid = false
                result.message = this.getString('valor_informado_casas_decimais')
                return result
            }

            if (!this.selectedSaleType[0]) {
                result.isValid = false
                result.message = this.getString('selecione_tipo_cancelamento')
                return result
            }

            return result
        },
        saleTypeChange: function (saleType, event) {
            this.selectedSaleType = []
            if (event && event.srcElement.checked) {
                this.selectedSaleType.push(saleType)
            }
        },
        showFuncoesAdministrativasOptions: async function (data) {
            if (data && data.length > 0 && data !== this.lastdata) {
                this.tefMessage = ''
                this.lastdata = JSON.parse(JSON.stringify(data))
                this.funcoesAdministrativasOptions = data.split(';')
                this.funcoesAdministrativasOptions = this.funcoesAdministrativasOptions.filter(option => option && option.length > 0)
            }

            if (Util.isAndroidMode()) {
                await waitForDOMUpdate.waitForDOMUpdate()
            }
        },
        setFuncoesAdministrativasSelected: async function (selected) {
            this.tefMessage = 'Aguarde...'
            const selectedNumber = selected.split(':')[0].trim()
            if (selectedNumber && selectedNumber !== '') {
                PaymentController.setFuncoesAdministrativasSelected(selectedNumber)
            } else {
                Util.showInfoModal(LocaleController.getString('opcao_invalida'))
            }
            if (Util.isAndroidMode()) {
                await waitForDOMUpdate.waitForDOMUpdate()
            }
        },
        setTefMessageCancelTef: function (data) {
            this.tefMessage = data
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 90px;
    background: @white;
    border-radius: 25px;
    z-index: 20;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    max-height: 800px;
    display: grid;
    grid-template-rows: auto 1fr 180px;

    .modal-form-container {
        position: relative;
        overflow: hidden auto;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;

            h2 {
                color: @white;
                margin: auto;
            }
        }
    }

    .form {
        margin: 0px 60px 0px 60px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden auto;

        .config-item {
            display: grid;
            grid-template-columns: 40% 60%;
            position: relative;

            label {
                position: relative;
                display: inline-block;
                top: 50%;
                transform: translate(0, -50%);
                margin: 0;
            }

            input {
                vertical-align: middle;
                font-size: 2rem;
                padding: 5px 15px;
                border: 2px solid @primary-color;
                outline: none;

                &[type=text] {
                    color: black;
                }

                &[type=color] {
                    border: none;
                    height: 100px;
                    width: 100%;
                    box-sizing: inherit;
                    appearance: initial;
                    padding: 0;
                }
            }
        }

        .distance-bottom {
            margin-bottom: 45px;
        }

        .sale-type-radios {
            display: grid;
            grid-template-columns: 1fr 1fr 2fr;

            .option {
                display: flex;
                margin-top: 15px;
                padding-left: 30px;
                align-items: center;
                grid-template-columns: 20% 80%;
            }
        }
    }

    .main-area {
        display: flex;
        flex-direction: column;
        overflow: hidden auto;
        position: relative;
        height: auto;
        padding: 20px 0;
        flex: 1;
        &.funcoes-administrativas-message-box {
            position: absolute;
        }

        .funcoes-administrativas-options {
            display: flex;
            flex-direction: column;
            align-items: left;
            justify-content: flex-start;
            flex: 1;

            .option {
                display: flex;
                padding: 15px 20px;
                align-items: center;
                border-bottom: 1px solid black;
                justify-content: left;
            }

            .message-box {
                display: flex;
                align-items: center;
                justify-content: center;
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 20;
                background-color: rgba(0, 0, 0, 0.6);
                .message {
                    font-size: 35px;
                    background-color: @white;
                    padding: 40px 60px;
                    border-radius: 10px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                    max-width: 70%;
                    text-align: center;
                }
            }
        }

        .screen-printed {
            font-size: 25px;
            margin: auto;
        }

        .sale-type-radios {
            .option {
                display: flex;
                margin-top: 15px;
                align-items: center;
                grid-template-columns: 20% 80%;
            }
        }

        .label-text {
            font-size: 30px;
        }

        .sales-table {
            width: 98%;

            th,
            td {
                padding: 10px 5px;
                text-align: center;
            }

            th {
                font-weight: normal;
                border-bottom: 1px solid black;
            }

            tr:nth-child(even) {
                background-color: #f2f2f2;
            }
        }
    }

    .prod-item-footer {
        position: relative;
        display: grid;
        grid-template-columns: auto auto;
        background: rgba(0, 0, 0, 0.1);
        height: 180px;
        border-radius: 0px 0px 25px 25px;

        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }

    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 19;
    }

    .wallet-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 21;
        display: flex;
        flex-direction: column;
        background: white;
        max-height: 700px;
        width: 600px;
        margin: auto;
        border-radius: 25px;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;

            h2 {
                color: @white;
                margin: auto;
                font-size: 50px;
            }
        }

        .main-area {
            // flex-grow: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 600px;
            overflow: auto;

            .wallet-button {
                margin: 15px 0px;
                // width: 100%;
            }
        }
    }
}

#keyboard {
    .keyboard;
}

@media (max-width: 698px) {

    // Gertec SK210
    .modal-container {
        grid-template-rows: auto 1fr 70px;
        margin: 50px 30px auto 30px;
        max-height: 480px;

        .modal-form-container {
            .title-box {
                height: 50px;
                margin-bottom: 0;

                h2 {
                    font-size: 25px;
                }
            }
        }

        .form {
            height: calc(100% - 40px);
            margin: 0 30px 0 30px;

            .config-item {
                grid-template-columns: 35% 65%;
                font-size: 18px;

                input {
                    font-size: 18px;
                    height: 25px;
                    padding: 0 10px;
                }
            }

            .distance-bottom {
                margin-bottom: 20px;
            }

            .sale-type-radios {
                grid-template-columns: 1fr 1fr 2fr;

                .option {
                    margin-top: 0;
                    padding-left: 0;

                    .container-input {
                        margin-right: 5px;
                    }

                    label {
                        margin-right: 5px;
                        font-size: 16px;
                    }
                }
            }
        }

        .main-area {
            padding: 20px 0;
            flex: 1;

            .funcoes-administrativas-options {
                .option {
                    display: flex;
                    padding: 10px 15px;
                }

                .message-box {
                    .message {
                        font-size: 18px;
                        background-color: @white;
                        padding: 20px 40px;
                        border-radius: 10px;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                        max-width: 80%;
                        text-align: center;
                    }
                }
            }

            .screen-printed {
                font-size: 25px;
                margin: auto;
            }
        }

        .prod-item-footer {
            height: 70px;
        }

        .wallet-modal {
            max-height: 350px;
            width: 330px;

            .title-box {
                height: 50px;

                h2 {
                    font-size: 25px;
                }
            }

            .main-area {
                height: 300px;
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    //@tablet

    .modal-container {
        grid-template-rows: auto 1fr 130px;
        margin: auto 50px;
        height: 800px;

        .modal-form-container {
            padding: 0;
            margin: 0;

            .title-box {
                height: 100px;
                margin-bottom: 0;
                h2 {
                    font-size: 30px;
                }
            }
        }

        .form {
            // height: calc(100% - 165px);
            height: 100%;
            margin: 0 30px;

            .config-item {
                grid-template-columns: 30% 70%;
            }
        }

        .main-area {
            height: auto;
            // margin: 0 60px;
            padding: 0 0;
            flex: 1;

            .funcoes-administrativas-options {
                .option {
                    display: flex;
                    padding: 15px 20px;
                    align-items: center;
                    border-bottom: 1px solid black;
                    justify-content: left;
                }
                .message-box {
                    .message {
                        max-width: 70%;
                        font-size: 30px;
                    }
                }
            }
        }

        .prod-item-footer {
            height: 130px;
        }
    }

    #keyboard {
        .keyboard;
        max-width: 760px;
        font-size: 20px;
        position: fixed;
        bottom: 0;
        width: 95%;
    }
}

@media (orientation: landscape) {
    .modal-container {
        margin: auto 140px;
        height: 600px;
        grid-template-rows: auto 1fr 70px;
        .modal-form-container {
            .title-box {
                height: 50px;
                margin-bottom: 0;

                h2 {
                    font-size: 25px;
                }
            }
        }

        .form {
            height: auto;
            margin: 40px;

            .config-item {
                grid-template-columns: 30% 70%;

                input {
                    font-size: 20px;
                    height: 30px;
                    padding: 0 10px;
                }
            }

            .distance-bottom {
                margin-bottom: 40px;
            }

            .sale-type-radios {
                grid-template-columns: 1fr 1fr 2fr;

                .option {
                    margin-top: 0;
                    padding-left: 0;

                    .container-input {
                        margin-right: 20px;
                    }

                    label {
                        margin-right: 5px;
                    }
                }
            }
        }

        .main-area {
            height: auto;
            padding: 0 0;
            flex: 1;

            .funcoes-administrativas-options {
                .option {
                    display: flex;
                    padding: 15px 20px;
                    align-items: center;
                    border-bottom: 1px solid black;
                    justify-content: left;
                }

                .message-box {
                    .message {
                        font-size: 28px;
                        padding: 35px 50px;
                        border-radius: 10px;
                        text-align: center;
                    }
                }
            }
        }

        .prod-item-footer {
            height: 70px;
        }

        .wallet-modal {
            max-height: 350px;
            width: 330px;

            .title-box {
                height: 50px;

                h2 {
                    font-size: 25px;
                }
            }

            .main-area {
                height: 300px;
            }
        }
    }

    #keyboard {
        max-width: 600px;
        font-size: 18px;
        position: fixed;
        bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CancelTefModal.vue